module.exports = "<gw-definition-list\r\n        title=\"{{ 'gateway.contacts.components.ContactDetails.Roles.Additional Insured.Title' | translate }}\"\r\n>\r\n\r\n    <gw-definition\r\n            ng-repeat=\"type in $ctrl.additionalInsuredTypes\"\r\n    >\r\n        {{ type }}\r\n    </gw-definition>\r\n</gw-definition-list>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/contacts/common/components/roles/ContactRoleAdditionalInsured/ContactRoleAdditionalInsured.html
// module id = 698
// module chunks = 0